module.exports = __webpack_public_path__ + "static/49-56c41591c782bae8cbf3eff3d56ec0d7.jpg";